import React, {useState} from "react";
import {Button, Card, Modal} from "flowbite-react";
import Code from "../Code";
import {toast} from "react-toastify";

const formTemplates = [
    { id: 1, title: "Contact Form", description: "A simple contact form to receive messages from your users in your inbox.",
        template: `<form action="${process.env.REACT_APP_FORMY_LINK_TEMPLATE}" method="post">
    <input type="email" name="email">
    <textarea name="message"></textarea>
    <input type="submit" value="send">
</form>` },
    { id: 2, title: "Order Form", description: "Sell your items with this most popular order form template.",
        template: `<form action="${process.env.REACT_APP_FORMY_LINK_TEMPLATE}" method="post">
    <input type="text" name="name">
    <input type="text" name="phone">
    <input type="text" name="product">
    <textarea name="address"></textarea>
    <input type="submit" value="send">
</form>` },
    { id: 3, title: "Online Quiz", description: "A generic quiz template that you can edit with your questions and share online.",
        template: `<form action="${process.env.REACT_APP_FORMY_LINK_TEMPLATE}" method="post">
    <input type="text" name="name">
    <input type="text" name="phone">
    <input name="which_radio" value="one" type="radio">
    <input name="which_radio" value="two" type="radio">
    <input name="which_radio" value="three" type="radio">
    <input name="which_select[]" value="first" type="checkbox">
    <input name="which_select[]" value="second" type="checkbox">
    <input type="submit" value="send">
</form>` },
    { id: 4, title: "Survey Form", description: "Gather feedback with this survey form.",
        template: `<form action="${process.env.REACT_APP_FORMY_LINK_TEMPLATE}" method="post">
    <input type="text" name="name">
    <input type="text" name="phone">
    <input name="which_radio" value="one" type="radio">
    <input name="which_radio" value="two" type="radio">
    <input name="which_radio" value="three" type="radio">
    <textarea name="comment"></textarea>
    <input type="submit" value="send">
</form>` },
    { id: 5, title: "Booking Form", description: "Allow users to book an appointment or reservation.",
        template: `<form action="${process.env.REACT_APP_FORMY_LINK_TEMPLATE}" method="post">
    <input type="text" name="name">
    <input type="text" name="phone">
    <input type="datetime-local" name="date">
    <select name="count">
        <option value="1" selected="selected">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
    </select>
    <input type="submit" value="send">
</form>` }
];

const PrebuiltForms = () => {
    const [activeModal, setActiveModal] = useState(null);

    const toggleModal = (id) => {
        setActiveModal(activeModal === id ? null : id);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Copied to clipboard.", { position: "bottom-center", autoClose: 5000, theme: "dark" });
    };

    return (
        <section className="bg-white dark:bg-gray-900" id="prebuilt-forms">
            <div className="py-8 pb-12 px-4 mx-auto max-w-screen-xl">
                <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                        Pre-built Forms
                    </h2>
                    <p className="mb-5 font-light sm:text-xl text-gray-900 dark:text-white">
                        Just copy-paste our pre-built forms to your site
                    </p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-10">
                    {formTemplates.map(({ id, title, description, template }) => (
                        <Card key={id} className="max-w-sm forms-cards">
                            <h5 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
                                {title}
                            </h5>
                            <p className="font-normal text-gray-700 dark:text-gray-400">
                                {description}
                            </p>
                            <div className="flex items-center justify-between mt-1">
                                <span className="text-2xl font-bold text-gray-900 dark:text-white">Free</span>
                                <Button onClick={() => toggleModal(id)}>Show code</Button>
                            </div>
                            <Modal show={activeModal === id} onClose={() => toggleModal(null)} dismissible>
                                <Modal.Header>{title}</Modal.Header>
                                <Modal.Body className="p-0">
                                    <Code code={template} language="html"/>
                                </Modal.Body>
                                <Modal.Footer className="flex justify-center">
                                    <Button color="gray" onClick={() => toggleModal(null)}>Close</Button>
                                    <Button onClick={() => copyToClipboard(template)}>Copy code</Button>
                                </Modal.Footer>
                            </Modal>
                        </Card>
                    ))}
                    <Card className="max-w-sm relative h-20 md:h-full" id="coming-card">
                        <div
                            className="text-center absolute w-full h-full grid place-items-center text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
                            Coming Soon
                        </div>
                    </Card>
                </div>
            </div>
        </section>
    );
};

export default PrebuiltForms;
